/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".body[_ngcontent-%COMP%]{max-width:600px;display:flex;flex-direction:column}.body[_ngcontent-%COMP%]   .button-containers[_ngcontent-%COMP%]{display:flex;justify-content:space-between;margin-top:8px}"];
export { styles as styles };
